/**
 * In-app notifications service.
 *
 * Backed by /notifications endpoints. Used by the dashboard bell to surface
 * events like exec-posted notes to the assigned EAs.
 */

import axios from 'axios';
import { getApiBase, getAuthHeaders } from '../utils/api';

export async function listNotifications({ unreadOnly = false, limit = 50 } = {}) {
  const apiBase = getApiBase();
  const headers = getAuthHeaders();
  const params = new URLSearchParams();
  if (unreadOnly) params.set('unread_only', 'true');
  if (limit) params.set('limit', String(limit));
  const url = `${apiBase}/notifications${params.toString() ? `?${params.toString()}` : ''}`;
  const response = await axios.get(url, { headers });
  return response.data?.items || [];
}

export async function getUnreadCount() {
  const apiBase = getApiBase();
  const headers = getAuthHeaders();
  const response = await axios.get(`${apiBase}/notifications/unread-count`, { headers });
  return response.data?.count || 0;
}

export async function markNotificationRead(notificationId) {
  const apiBase = getApiBase();
  const headers = getAuthHeaders();
  const response = await axios.patch(
    `${apiBase}/notifications/${notificationId}/read`,
    {},
    { headers }
  );
  return response.data;
}

export async function markAllNotificationsRead() {
  const apiBase = getApiBase();
  const headers = getAuthHeaders();
  const response = await axios.post(
    `${apiBase}/notifications/mark-all-read`,
    {},
    { headers }
  );
  return response.data;
}
